/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workflow_Node_ActiveInputs */

const cs_workflow_node_active = /** @type {(inputs: Workflow_Node_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktivní`)
};

const en_workflow_node_active = /** @type {(inputs: Workflow_Node_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Active`)
};

/**
* | output |
* | --- |
* | "Active" |
*
* @param {Workflow_Node_ActiveInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const workflow_node_active = /** @type {((inputs?: Workflow_Node_ActiveInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workflow_Node_ActiveInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_workflow_node_active(inputs)
	return cs_workflow_node_active(inputs)
});